<script>
import { getFunctions, httpsCallable } from "firebase/functions";
import { doc, getFirestore, getDoc, updateDoc } from "firebase/firestore";

export default {
  name: "StrappAcceptDecline",

  props: {
    booking: {
      type: Object,
      required: true,
    },
  },

  components: {
    // stitch: () => import('./Stitch.vue'),
    DeclineBookingDialog: () => import("@/components/declineBookingDialog.vue"),
    StitchVerifyDialog: () =>
      import("@/components/booking/stitchVerifyDialog.vue"),
  },

  data() {
    return {
      verifyAcceptDialog: false,
      acceptedDialog: false,
      loading: false,
      VerifyDialog: false,
      linkVerifyInfoClicked: false,
      linkVerifyInfo: false,
      manualVerifyInfoClicked: false,
      verifyRadio: "auto",
      manualVerifDisabled: false,
    };
  },

  mounted() {
    console.log(
      this.$store.getters.user.stitch_verification_received ||
        this.$store.getters.user.manual_verification_received
    );
    console.log(_.isEmpty(this.$store.getters.user.verified));
    console.log("verified", this.verified);
  },

  computed: {
    verified() {
      if (
        this.$store.getters.user.stitch_verification_received ||
        this.$store.getters.user.manual_verification_received ||
        this.$store.getters.user.verified
      ) {
        return true;
      } else {
        return false;
      }
    },
  },

  methods: {
    async NextVerify() {
      //get selected radio button
      console.log("radio", this.verifyRadio);
      this.loading = true;

      if (this.verifyRadio == "auto") {
        this.verifyAcceptDialog = true;
        this.VerifyDialog = false;
      } else if (this.verifyRadio == "manual") {
        console.log(this.booking);
        this.$router.push({
          name: `Verify 📊`,
          params: { booking: this.booking },
        });
      }
    },
    async Verifychoice() {
      this.loadingPayMethod = true;

      this.$router.push({
        name: `Verify 📊`,
        params: { booking: this.booking },
      });

      // const db = getFirestore();
      // const userRef = doc(db, "users", this.$store.state.user.id);
      // const userSnap = await getDoc(userRef);
      // console.log("userSnap", userSnap.data());

      // const user = userSnap.data();

      // this.user = user;

      // if (user.manual_verification_received) {
      //   this.verification_received = true;
      //   this.VerifyDialog = true;
      //   this.manualVerifDisabled = true;
      // } else if (user.stitch_verification_received) {
      //   this.verification_received = true;
      //   this.VerifyDialog = true;
      //   this.autoVerifDisabled = true;
      // } else if (
      //   !user.stitch_verification_received &&
      //   !user.manual_verification_received
      // ) {
      //   this.VerifyDialog = true;
      //   this.verification_received = false;
      // }
    },
    async acceptBooking(booking) {
      // console.log(booking);
      this.$store.commit("setLoading", true);
      this.loading = true;
      console.log(booking.id);
      console.log(booking.borrowerName);
      console.log(booking.borrowerID);
      console.log(booking.itemName);

      try {
        // Assuming 'booking' is properly initialized
        const addMessage = httpsCallable(
          getFunctions(),
          "BookingAcceptedTriggerEmails"
        );
        const response = await addMessage({
          id: booking.id,
          borrowerName: booking.borrowerName,
          borrowerID: booking.borrowerID,
          itemName: booking.itemName,
        });
        console.log(response);
        try {
          await this.$store
            .dispatch("updateBookingData", {
              id: booking.id,
              status: "awaiting-payment",
              updatedAt: new Date(),
            })
            .then(() => {
              console.log("AYOOOOO");
            });
        } catch (error) {
          const errorMessage = error.message;
          alert(errorMessage);
        }
      } catch (error) {
        console.error("Client-side error:", error);
        alert("An error occurred: " + error.message);
      } finally {
        this.acceptedDialog = true;
        this.$store.commit("setLoading", false);
      }
    },
  },
};
</script>

<template>
  <div>
    <v-row class="grid" width="100%" v-if="verified == false">
      <!-- <v-card-title class="text-center mt-4 hidden-sm-and-down"
        >Accept or decline Booking</v-card-title
      > -->
      <v-row class="mt-2 text-center grid"
        ><p class="text-body-1 hidden-sm-and-down">
          Verification is required to accept this booking.
        </p>
        <br />
      </v-row>
    </v-row>

    <v-row class="mb-2">
      <v-col>
        <v-hover v-slot="{ hover }" v-if="this.verified == true">
          <v-btn
            class="white--text mx-1 mt-3 font-weight-medium"
            color="accent"
            :elevation="hover ? 16 : 4"
            :class="{ 'on-hover': hover }"
            style="border-radius: 10px"
            block
            @click="acceptBooking(booking)"
          >
            <v-icon class="mr-3">fas fa-check</v-icon>
            Accept
          </v-btn>
        </v-hover>

        <v-btn
          v-if="this.verified == false"
          class="white--text mx-1 mt-3 font-weight-medium"
          color="accent"
          style="border-radius: 10px"
          block
          @click="Verifychoice()"
        >
          <v-img
            width="20px"
            height="20px"
            class="mr-3"
            :src="require('@/assets/fontawesome/check-duotone.svg')"
          />
          <span class="hidden-sm-and-down">Verify &</span> Accept
        </v-btn>
      </v-col>

      <v-col>
        <decline-booking-dialog :booking="booking"></decline-booking-dialog>
      </v-col>
    </v-row>

    <v-dialog
      v-model="VerifyDialog"
      max-width="550px"
      persistent
      style="border-radius: 16px"
    >
      <v-card scrollable>
        <v-overlay v-if="loading" class="grid pa-12"> </v-overlay>
        <div class="grid pt-12">
          <v-row>
            <v-card class="mr-5" style="border-radius: 12px">
              <base-img
                :src="require('@/assets/logos/icon1.svg')"
                class="mx-auto pa-6"
                contain
                width="12"
              />
            </v-card>
          </v-row>
          <v-divider></v-divider>
          <v-card-title class="text-center mt-4"
            >Strapp verification</v-card-title
          >

          <v-card-text class="text-caption text-center">
            For your own safety and the safety of fellow Strappers you are
            required to verify your profile before any bookings can be
            finalized.
          </v-card-text>

          <router-link to="/faq" target="_blank" class="text-app" small
            ><p class="caption text-underline">Learn more</p>
          </router-link>

          <v-radio-group class="mt-n4" v-model="verifyRadio" column>
            <v-card class="pa-4 ma-4" outlined>
              <v-radio value="auto">
                <template v-slot:label>
                  <p class="body-2">
                    <span class="body-2 font-weight-bold">
                      <v-img
                        contain
                        max-height="50"
                        max-width="70"
                        :src="require('@/assets/logos/stitch.webp')"
                        :lazy-src="require('@/assets/logos/stitch.webp')"
                      />
                      LinkPay (recommended)
                      <v-icon
                        small
                        @click="linkVerifyInfoClicked = !linkVerifyInfoClicked"
                        >mdi-information</v-icon
                      ></span
                    >
                    <br />
                    <span class="caption"
                      >Automatic Verification and Account linking with
                      Stitch</span
                    >
                    <span
                      class="caption font-weight-medium"
                      v-if="linkVerifyInfoClicked"
                      ><br />
                      This links your account by adding Strapp as a beneficiary
                      and will enable ease of payment and payouts going forward
                      <br />
                    </span>
                    <br v-if="!linkVerifyInfoClicked" />
                    <span class="caption red--text"
                      >Capitec not currently supported</span
                    >
                  </p>
                </template></v-radio
              >
            </v-card>
            <v-card
              class="pa-4 ma-4 mt-n2"
              :color="this.manualVerifDisabled ? 'grey lighten-3' : ''"
              outlined
            >
              <v-radio
                :disabled="this.manualVerifDisabled"
                label="Manual Payment and Verification"
                value="manual"
              >
                <template v-slot:label>
                  <div>
                    <p class="caption" v-if="manualVerifDisabled">
                      <strong class="body-2 font-weight-bold">
                        Manual Verification</strong
                      >
                      <v-icon
                        small
                        @click="
                          manualVerifyInfoClicked = !manualVerifyInfoClicked
                        "
                        >mdi-information</v-icon
                      >
                      <br />
                      You have already requested a manual verification
                      <span v-if="manualVerifyInfoClicked"
                        ><br />You should receive an email <br
                      /></span>
                    </p>
                    <p class="caption" v-else>
                      <strong class="body-2 font-weight-bold">
                        Manual Verification</strong
                      >
                      <v-icon
                        small
                        @click="
                          manualVerifyInfoClicked = !manualVerifyInfoClicked
                        "
                        >mdi-information</v-icon
                      >
                      <br />Manual verification via document upload and payfast
                      link email
                      <span v-if="manualVerifyInfoClicked"
                        ><br />This will allow you to upload your verification
                        documents manually in order to verify yourself<br
                      /></span>
                    </p>
                  </div> </template
              ></v-radio>
            </v-card>
          </v-radio-group>
          <hr />
        </div>
        <v-card-actions class="mt-n6">
          <v-btn large color="blue darken-1" text @click="VerifyDialog = false">
            Close
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
            large
            color="accent darken-1"
            :loading="loading"
            text
            @click="NextVerify()"
          >
            Verify & Pay
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="verifyAcceptDialog"
      scrollable
      max-width="450px"
      style="border-radius: 12px"
    >
      <stitch-verify-dialog :booking="booking" />
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped></style>
